/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_Shared_Hosting_Etos_ActivityTracingInfo } from '../models/Wealthlane_Shared_Hosting_Etos_ActivityTracingInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class EsppPurchasePublishTaskHandlingService {

    /**
     * @param taskId 
     * @param tenantId 
     * @param userId 
     * @param taskInstruction 
     * @param requestBody 
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAwardApiAppEsppPurchasePublishTaskHandlingBackgroundPublishPurchase(
taskId?: string,
tenantId?: string,
userId?: string,
taskInstruction?: string,
requestBody?: Wealthlane_Shared_Hosting_Etos_ActivityTracingInfo,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/espp-purchase-publish-task-handling/background-publish-purchase',
            query: {
                'taskId': taskId,
                'tenantId': tenantId,
                'userId': userId,
                'taskInstruction': taskInstruction,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
